// ****DONT EDIT THIS FILE****
//
// This file is automatically generated by the automateIcons.sh script.
// To update the icons, run the script and it will automatically update this file.
// If you need to add new icons, add the SVG files to the assets/icons directory and run the script.
// The script will automatically update this file with the new icons.
// To run the script, run npm run generate_icons

import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as MenuActiveLinkIcon } from '@Assets/icons/menu-active-link.svg';
import { ReactComponent as CheckmarkIcon } from '@Assets/icons/checkmark.svg';
import { ReactComponent as AccountAccessIcon } from '@Assets/icons/account-access.svg';
import { ReactComponent as IndustryMarijuanaIcon } from '@Assets/icons/industry-marijuana.svg';
import { ReactComponent as ArrowIcon } from '@Assets/icons/arrow.svg';
import { ReactComponent as ExpressIcon } from '@Assets/icons/express.svg';
import { ReactComponent as MobileBackIcon } from '@Assets/icons/mobile-back.svg';
import { ReactComponent as Industry18PlusIcon } from '@Assets/icons/industry-18-plus.svg';
import { ReactComponent as IcSuccessBlueIcon } from '@Assets/icons/ic-success-blue.svg';
import { ReactComponent as LinkViaTextIcon } from '@Assets/icons/link-via-text.svg';
import { ReactComponent as IndustryMoneyservicesIcon } from '@Assets/icons/industry-moneyservices.svg';
import { ReactComponent as OopsIcon } from '@Assets/icons/oops.svg';
import { ReactComponent as EllipseIcon } from '@Assets/icons/ellipse.svg';
import { ReactComponent as ShieldIcon } from '@Assets/icons/shield.svg';
import { ReactComponent as ExpandIcon } from '@Assets/icons/expand.svg';
import { ReactComponent as IndustryAtmIcon } from '@Assets/icons/industry-atm.svg';
import { ReactComponent as PlusIcon } from '@Assets/icons/plus.svg';
import { ReactComponent as InfoIcon } from '@Assets/icons/Info.svg';
import { ReactComponent as IndustryCryptocurrenciesIcon } from '@Assets/icons/industry-cryptocurrencies.svg';
import { ReactComponent as IndustryCrowdfundingIcon } from '@Assets/icons/industry-crowdfunding.svg';
import { ReactComponent as IndustryNonprofitIcon } from '@Assets/icons/industry-nonprofit.svg';
import { ReactComponent as IcErrorOrangeIcon } from '@Assets/icons/ic-error-orange.svg';
import { ReactComponent as SocureInstruction3Icon } from '@Assets/icons/socure-instruction-3.svg';
import { ReactComponent as IndustryFirearmManufacturingIcon } from '@Assets/icons/industry-firearm-manufacturing.svg';
import { ReactComponent as EyeVisibleIcon } from '@Assets/icons/eye-visible.svg';
import { ReactComponent as SocureInstruction2Icon } from '@Assets/icons/socure-instruction-2.svg';
import { ReactComponent as EditIcon } from '@Assets/icons/edit.svg';
import { ReactComponent as IndustryGamblingIcon } from '@Assets/icons/industry-gambling.svg';
import { ReactComponent as SocureInstruction1Icon } from '@Assets/icons/socure-instruction-1.svg';
import { ReactComponent as DeleteIcon } from '@Assets/icons/delete.svg';
import { ReactComponent as SuccessIcon } from '@Assets/icons/success.svg';
import { ReactComponent as EyeIcon } from '@Assets/icons/eye.svg';
import { ReactComponent as IndustryTrustIcon } from '@Assets/icons/industry-trust.svg';
import { ReactComponent as CalendarIcon } from '@Assets/icons/calendar.svg';
import { ReactComponent as ErrorIcon } from '@Assets/icons/error.svg';
import { ReactComponent as HelpIcon } from '@Assets/icons/Help.svg';
import { ReactComponent as ExitIconIcon } from '@Assets/icons/exit-icon.svg';
import { ReactComponent as IcColoredCircleCheckmarkIcon } from '@Assets/icons/ic-colored-circle-checkmark.svg';


// Define the icon variants
export enum Icons {
  MenuActiveLink = 'menu-active-link',
  Checkmark = 'checkmark',
  AccountAccess = 'account-access',
  IndustryMarijuana = 'industry-marijuana',
  Arrow = 'arrow',
  Express = 'express',
  MobileBack = 'mobile-back',
  Industry18Plus = 'industry-18-plus',
  IcSuccessBlue = 'ic-success-blue',
  LinkViaText = 'link-via-text',
  IndustryMoneyservices = 'industry-moneyservices',
  Oops = 'oops',
  Ellipse = 'ellipse',
  Shield = 'shield',
  Expand = 'expand',
  IndustryAtm = 'industry-atm',
  Plus = 'plus',
  Info = 'Info',
  IndustryCryptocurrencies = 'industry-cryptocurrencies',
  IndustryCrowdfunding = 'industry-crowdfunding',
  IndustryNonprofit = 'industry-nonprofit',
  IcErrorOrange = 'ic-error-orange',
  SocureInstruction3 = 'socure-instruction-3',
  IndustryFirearmManufacturing = 'industry-firearm-manufacturing',
  EyeVisible = 'eye-visible',
  SocureInstruction2 = 'socure-instruction-2',
  Edit = 'edit',
  IndustryGambling = 'industry-gambling',
  SocureInstruction1 = 'socure-instruction-1',
  Delete = 'delete',
  Success = 'success',
  Eye = 'eye',
  IndustryTrust = 'industry-trust',
  Calendar = 'calendar',
  Error = 'error',
  Help = 'Help',
  ExitIcon = 'exit-icon',
  IcColoredCircleCheckmark = 'ic-colored-circle-checkmark',
}


// Define the props for the Icon component
export interface IconProps extends HTMLAttributes<SVGElement> {
  icon: Icons;
  className?: string;
}

// Map variants to specific icon components
const mapVariantToIcon: Record<Icons, (props: HTMLAttributes<SVGElement>) => JSX.Element> = {
  [Icons.MenuActiveLink]: (props: HTMLAttributes<SVGElement>) => (
    <MenuActiveLinkIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Checkmark]: (props: HTMLAttributes<SVGElement>) => (
    <CheckmarkIcon {...props} className={`${props.className}`} />
  ),

  [Icons.AccountAccess]: (props: HTMLAttributes<SVGElement>) => (
    <AccountAccessIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryMarijuana]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryMarijuanaIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Arrow]: (props: HTMLAttributes<SVGElement>) => (
    <ArrowIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Express]: (props: HTMLAttributes<SVGElement>) => (
    <ExpressIcon {...props} className={`${props.className}`} />
  ),

  [Icons.MobileBack]: (props: HTMLAttributes<SVGElement>) => (
    <MobileBackIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Industry18Plus]: (props: HTMLAttributes<SVGElement>) => (
    <Industry18PlusIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IcSuccessBlue]: (props: HTMLAttributes<SVGElement>) => (
    <IcSuccessBlueIcon {...props} className={`${props.className}`} />
  ),

  [Icons.LinkViaText]: (props: HTMLAttributes<SVGElement>) => (
    <LinkViaTextIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryMoneyservices]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryMoneyservicesIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Oops]: (props: HTMLAttributes<SVGElement>) => (
    <OopsIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Ellipse]: (props: HTMLAttributes<SVGElement>) => (
    <EllipseIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Shield]: (props: HTMLAttributes<SVGElement>) => (
    <ShieldIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Expand]: (props: HTMLAttributes<SVGElement>) => (
    <ExpandIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryAtm]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryAtmIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Plus]: (props: HTMLAttributes<SVGElement>) => (
    <PlusIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Info]: (props: HTMLAttributes<SVGElement>) => (
    <InfoIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryCryptocurrencies]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryCryptocurrenciesIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryCrowdfunding]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryCrowdfundingIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryNonprofit]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryNonprofitIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IcErrorOrange]: (props: HTMLAttributes<SVGElement>) => (
    <IcErrorOrangeIcon {...props} className={`${props.className}`} />
  ),

  [Icons.SocureInstruction3]: (props: HTMLAttributes<SVGElement>) => (
    <SocureInstruction3Icon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryFirearmManufacturing]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryFirearmManufacturingIcon {...props} className={`${props.className}`} />
  ),

  [Icons.EyeVisible]: (props: HTMLAttributes<SVGElement>) => (
    <EyeVisibleIcon {...props} className={`${props.className}`} />
  ),

  [Icons.SocureInstruction2]: (props: HTMLAttributes<SVGElement>) => (
    <SocureInstruction2Icon {...props} className={`${props.className}`} />
  ),

  [Icons.Edit]: (props: HTMLAttributes<SVGElement>) => (
    <EditIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryGambling]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryGamblingIcon {...props} className={`${props.className}`} />
  ),

  [Icons.SocureInstruction1]: (props: HTMLAttributes<SVGElement>) => (
    <SocureInstruction1Icon {...props} className={`${props.className}`} />
  ),

  [Icons.Delete]: (props: HTMLAttributes<SVGElement>) => (
    <DeleteIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Success]: (props: HTMLAttributes<SVGElement>) => (
    <SuccessIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Eye]: (props: HTMLAttributes<SVGElement>) => (
    <EyeIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IndustryTrust]: (props: HTMLAttributes<SVGElement>) => (
    <IndustryTrustIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Calendar]: (props: HTMLAttributes<SVGElement>) => (
    <CalendarIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Error]: (props: HTMLAttributes<SVGElement>) => (
    <ErrorIcon {...props} className={`${props.className}`} />
  ),

  [Icons.Help]: (props: HTMLAttributes<SVGElement>) => (
    <HelpIcon {...props} className={`${props.className}`} />
  ),

  [Icons.ExitIcon]: (props: HTMLAttributes<SVGElement>) => (
    <ExitIconIcon {...props} className={`${props.className}`} />
  ),

  [Icons.IcColoredCircleCheckmark]: (props: HTMLAttributes<SVGElement>) => (
    <IcColoredCircleCheckmarkIcon {...props} className={`${props.className}`} />
  ),

};


 export const Icon = (props: IconProps) => {
  const { icon, className = '', ...rest } = props;
  const IconComponent = mapVariantToIcon[icon];
  const style = twMerge(className);

  return <IconComponent className={style} {...rest} />;
}
